import { invitationApi, SendInvitationParams } from '../../hub/invitation';
import { MutationSchema } from '../types';
export const invitationMutations = {
  sendInvitation: (): MutationSchema<SendInvitationParams, any> => ({
    mutationKey: ['hub', 'invitation', 'send'],
    mutationFn: async (params: SendInvitationParams) => {
      return await invitationApi.sendInvitation(params);
    }
  })
};
